import Vue from 'vue'
import almacenDocumentos from './almacenDocumentos'
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import cartera from './cartera'
import contabilidad from './contabilidad'
import controlAsc from './controlAsc'
import controlAsistencia from './controlAsistencia'
import controlBines from './controlBines'
import controlCalidad from './controlCalidad'
import controlCostos from './controlCostos'
import controlTicket from './controlTicket'
import costos from './costos'
import cuentasxpagar from './cuentasxpagar'
import empresas from './empresas'
import evoucher from './evoucher'
import exportaciones from './exportaciones'
import financiero from './financiero'
import legal from './legal'
import logistica from './logistica'
import marketing from './marketing'
import monitoreoPesca from './monitoreoPesca'
import pallestizado from './pallestizado'
import panacea from './panacea'
import personas from './personas'
import personasPG from './personasPG'
import produccion from './produccion'
import produccionPG from './produccionPG'
import profremar from './profremar'
import recursosHumanos from './recursosHumanos'
import search from './search'
import sistemaDocumentos from './sistemaDocumentos'
import sistemas from './sistemas'
import solicitudCompra from './solicitudCompra'
import solicitudes from './solicitudes'
import sri from './sri'
import tableroControl from './tableroControl'
import temperatura from './temperatura'
import transferencias from './transferencias'
import tributacion from './tributacion'
import usuarios from './usuarios'
import ventas from './ventas'
import ventasNacionales from './ventasNacionales'
import verticalMenu from './vertical-menu'
import Vuex from 'vuex'
import administracion from './administracion/vuex'
import compras from './compras/vuex'
import inventarioConsumo from './inventarioConsumo/vuex'
import personas_v2 from './personas/v2'
import tributacion_v2 from './tributacion/v2'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        appConfig,
        auth,
        verticalMenu,
        empresas,
        produccion,
        exportaciones,
        personas,
        tributacion,
        controlBines,
        sri,
        cartera,
        financiero,
        almacenDocumentos,
        transferencias,
        usuarios,
        contabilidad,
        monitoreoPesca,
        sistemas,
        controlCalidad,
        pallestizado,
        ventas,
        legal,
        logistica,
        ventasNacionales,
        recursosHumanos,
        search,
        controlCostos,
        controlAsistencia,
        panacea,
        sistemaDocumentos,
        controlAsc,
        temperatura,
        costos,
        administracion,
        produccionPG,
        cuentasxpagar,
        profremar,
        personasPG,
        solicitudes,
        inventarioConsumo,
        tableroControl,
        controlTicket,
        tributacion_v2,
        personas_v2,
        marketing,
        evoucher,
        compras,
        solicitudCompra,
    },
    // strict: import.meta.env.DEV,
})

export const useStore = () => store

export default store
